<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top-clubsponsorship" *ngIf=" bannerplayerList?.type == 'Image'" [ngStyle]="{'background-image':'url(' + bannerplayerList?.image + ')'}">
		<div class="container">
			<div class="ashton-hero-top-clubsponsorship-detail" >
				<h2>{{bannerplayerList?.title}}</h2>
			</div>
		</div>
		<div class="ashton-hero-top-clubsponsorship-overlay"></div>
	</div>
	<div class="ashton-hero-shop-section">
		<div class="container">
			<div class="ashton-hero-shop-detail">
				<div class="red-titel">SHOP</div>
				<div class="ashton-hero-shop-detail-inner">
					<div class="ashton-hero-shop-detail-box" *ngFor="let product of productList?.data">
						<a href="{{product?.redirect_url}}" target="_blank">
							<div class="ashton-hero-shop-image">
								<img [src]="product?.image" alt="shop-one">
							</div>
							<div class="ashton-hero-shop-content">
								<div class="ashton-hero-shop-content-left">
									<h3>{{product?.title}}</h3>
									<p>£ {{product?.min_amount}}</p>
								</div>
								<div class="ashton-hero-shop-content-btn">
									<a href="{{product?.redirect_url}}" target="_blank">ADD TO CART</a>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends -->